<template>
    <v-select :items="tireTypeItems" :value="value" @input="syncValue" :label="label" placeholder="Alle"
              multiple hide-details/>
</template>

<script>
import {getTireTypes} from "@/helpers";

export default {
    props: {
        value: {
            type: Array,
            default: () => {
                return [];
            }
        },
        label: {
            type: String,
            default: () => {
                return 'Dekktyper';
            }
        },
        extraItems: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },

    methods: {
        syncValue(value) {
            this.$emit('input', value);
        }
    },
    computed: {
        tireTypeItems() {
            return [...getTireTypes(), ...this.extraItems];
        }
    },
}
</script>

<style scoped>

</style>
